import { render } from "./Section_Cash.vue?vue&type=template&id=3ecb674b"
import script from "./Section_Cash.vue?vue&type=script&lang=js"
export * from "./Section_Cash.vue?vue&type=script&lang=js"

import "./Section_Cash.vue?vue&type=style&index=0&id=3ecb674b&lang=scss"
script.render = render

export default script